export default __webpack_public_path__ + "static/media/social-twitter.dd52a2ec.svg";